export const en = {
    confirm:
        "The callout will be permanently deleted and won't be shown in any ads. If you only want to remove the callout from the current ad, delete it from the list on the right.",
    title: 'Permanently delete the callout?'
};
